<ng-container *ngIf="productSearchPage$ | async as productSearchPage">
  <ng-container *ngIf="productSearchPage.products.length">
    <div class="ds-grid">
      <div class="row mt-7">
        <div class="col">
          <h2 class="ds-heading--l text-center mb-0">{{'homepage.recentlyAdded' | cxTranslate}}</h2>
        </div>
      </div>
      <div class="row pt-6 tile-row">
        <ng-container *ngFor="let product of productSearchPage.products; let i = index">
          <div [ngClass]="{'d-sm-none': i > 1, 'd-lg-block': i === 2}" class="col-sm-6 col-lg-4 mb-7 mb-sm-6 tile-col">
            <dcp-product-tile [product]="product"></dcp-product-tile>
          </div>
        </ng-container>
      </div>
      <div class="row mb-6 d-none d-sm-flex">
        <div class="col">
          <button class="btn btn-outline-primary d-block mx-auto my-0"
                  type="button"
                  data-cy="view-all-recently-added"
                  (click)="launchSearchResult()">
            {{'productDetails.viewAll' | cxTranslate}}
          </button>
        </div>
      </div>
    </div>
  </ng-container>
</ng-container>
